module.exports = __webpack_public_path__ + "media/images/shop/photo_thumbnail4-348b98649350bea2736764ef777ad72c.jpg";